function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  filter: "url(#filter0_platinum)"
}, React.createElement("path", {
  d: "M3.10504 6C3.10504 4.34315 4.44819 3 6.10504 3H36.167C37.8238 3 39.167 4.34315 39.167 6V28.6023C39.167 29.6409 38.6298 30.6056 37.7469 31.1525L22.716 40.4646C21.748 41.0642 20.524 41.0642 19.5561 40.4646L4.5251 31.1525C3.64222 30.6056 3.10504 29.6409 3.10504 28.6023V6Z",
  fill: "url(#paint0_radial_29_31)"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  filter: "url(#filter0_d_29_31)"
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.9238 10.2139L12.9239 22.6196L17.8739 22.5902V18.3173H21.7312L25.0343 22.5864H29.7859L26.3579 18.1561C28.9875 17.6036 29.9818 15.7862 29.9818 14.2327C29.9818 12.3188 29.2168 10.2139 24.2561 10.2139L12.9238 10.2139ZM17.8585 12.9876H23.9541C23.9541 12.9876 25.1568 12.9876 25.1568 14.171C25.1568 15.3544 23.9541 15.4473 23.9541 15.4473H17.8585V12.9876Z",
  fill: "white"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  filter: "url(#filter1_d_29_31)"
}, React.createElement("path", {
  d: "M9.78876 29.5791V26.6879H11.0367C11.2513 26.6879 11.439 26.7303 11.6 26.815C11.7609 26.8997 11.8861 27.0187 11.9755 27.1721C12.0649 27.3255 12.1096 27.5048 12.1096 27.71C12.1096 27.917 12.0635 28.0963 11.9713 28.2479C11.88 28.3994 11.7515 28.5161 11.5859 28.598C11.4212 28.6798 11.2287 28.7208 11.0085 28.7208H10.2631V28.1109H10.8504C10.9426 28.1109 11.0212 28.0949 11.0861 28.0629C11.152 28.03 11.2024 27.9834 11.2372 27.9232C11.2729 27.8629 11.2908 27.7919 11.2908 27.71C11.2908 27.6272 11.2729 27.5566 11.2372 27.4982C11.2024 27.439 11.152 27.3938 11.0861 27.3627C11.0212 27.3307 10.9426 27.3147 10.8504 27.3147H10.5737V29.5791H9.78876ZM12.7951 29.5791V26.6879H13.58V28.9467H14.7489V29.5791H12.7951ZM16.2148 29.5791H15.3678L16.3221 26.6879H17.395L18.3493 29.5791H17.5023L16.8698 27.4841H16.8472L16.2148 29.5791ZM16.0567 28.4384H17.6491V29.0257H16.0567V28.4384ZM18.5813 27.3204V26.6879H21.0941V27.3204H20.2245V29.5791H19.4509V27.3204H18.5813ZM22.572 26.6879V29.5791H21.7871V26.6879H22.572ZM25.8431 26.6879V29.5791H25.188L24.1434 28.0601H24.1264V29.5791H23.3415V26.6879H24.0078L25.0356 28.2013H25.0582V26.6879H25.8431ZM28.3229 26.6879H29.1078V28.5401C29.1078 28.7603 29.0551 28.9509 28.9497 29.1118C28.8452 29.2718 28.6993 29.3956 28.512 29.4831C28.3248 29.5697 28.1073 29.613 27.8598 29.613C27.6104 29.613 27.3921 29.5697 27.2048 29.4831C27.0175 29.3956 26.8716 29.2718 26.7672 29.1118C26.6636 28.9509 26.6119 28.7603 26.6119 28.5401V26.6879H27.3968V28.4723C27.3968 28.5617 27.4166 28.6417 27.4561 28.7123C27.4956 28.782 27.5502 28.8365 27.6198 28.8761C27.6904 28.9156 27.7704 28.9354 27.8598 28.9354C27.9502 28.9354 28.0302 28.9156 28.0998 28.8761C28.1695 28.8365 28.2241 28.782 28.2636 28.7123C28.3031 28.6417 28.3229 28.5617 28.3229 28.4723V26.6879ZM29.8784 26.6879H30.8553L31.5272 28.3255H31.5611L32.2331 26.6879H33.21V29.5791H32.442V27.9076H32.4194L31.7757 29.5565H31.3127L30.6689 27.8963H30.6463V29.5791H29.8784V26.6879Z",
  fill: "white"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "filter0_platinum"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
})), React.createElement("filter", {
  id: "filter0_d_29_31",
  x: 11.4654,
  y: 10.2139,
  width: 19.9749,
  height: 15.3227,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), React.createElement("feOffset", {
  dy: 1.45847
}), React.createElement("feGaussianBlur", {
  stdDeviation: 0.729234
}), React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_29_31"
}), React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_29_31",
  result: "shape"
})), React.createElement("filter", {
  id: "filter1_d_29_31",
  x: 6.38777,
  y: 23.2869,
  width: 30.2232,
  height: 9.72702,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), React.createElement("feOffset", null), React.createElement("feGaussianBlur", {
  stdDeviation: 1.70049
}), React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.133333 0 0 0 0 0.137255 0 0 0 0 0.164706 0 0 0 1 0"
}), React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_29_31"
}), React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_29_31",
  result: "shape"
})), React.createElement("radialGradient", {
  id: "paint0_radial_29_31",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(21.1244 19.8074) rotate(90) scale(16.7302)"
}, React.createElement("stop", {
  stopColor: "#4A5B7D",
  stopOpacity: 0.95
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#1B1B20"
})));

var SvgPlatinumNoBorder = function SvgPlatinumNoBorder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPlatinumNoBorder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/platinum_no_border.77d09546.svg";
export { ForwardRef as ReactComponent };